import { render, staticRenderFns } from "./PaquetesArt.vue?vue&type=template&id=847ff3e6"
import script from "./PaquetesArt.vue?vue&type=script&lang=js"
export * from "./PaquetesArt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports